module.exports = __webpack_public_path__ + "static/media/Governing Board vs Working Board Video Script - Draft2_1586361053184.f4de17b5.docx";